import { useSelector } from "react-redux";
import { ROUTES } from "../constants/routes.constant";
import { RootState } from "../store/store";

export const getEventSteps = (event: any) => {
  const stepsInfo: string[] = Array.isArray(event?.steps_info)
    ? event?.steps_info
    : [];

  const STEPS: any[] = [
    {
      name: "Basic Info",
      description: "Add all of your event basic info",
      path: ROUTES.EDIT_EVENT?.path?.replace(":id", event?.id ?? ""),
      info: "basic_info",
      render: true,
      validate: true,
    },
    {
      name: "Event Details",
      description: "Add event details, banners and FAQ",
      path: ROUTES.ADD_EVENT_DETAILS?.path?.replace(":id", event?.id ?? ""),
      info: "event_details",
      render: true,
      validate: true,
    },
    {
      name: "Multi City Events",
      description: "",
      path: ROUTES.ADD_MULTI_EVENT?.path?.replace(":id", event?.id ?? ""),
      info: "multi_city",
      render: event?.is_group,
      validate: true,
    },
    {
      name: "Tickets",
      description: "",
      path: ROUTES.ADD_TICKET?.path?.replace(":id", event?.id ?? ""),
      info: "ticket_config",
      render:
        (event?.children && event?.children?.length > 0) || !event?.is_group,
      validate: true,
    },
    {
      name: "Registration Form",
      description: "",
      path: ROUTES.ADD_EVENT_CUSTOM_FORM?.path?.replace(":id", event?.id ?? ""),
      info: "custom_form",
      render: true,
      validate: true,
    },
  ];

  if (
    event?.status === "draft" ||
    event?.status === "approved" ||
    event?.status === "submitted" ||
    event?.status === "requested" ||
    event?.status === "rejected" ||
    event?.status === "published" ||
    event?.status === "scheduled"
  ) {
    const description =
      event?.status === "draft"
        ? "Submit for admin approval when ready"
        : event?.status === "approved"
          ? "Ready to publish"
          : event?.status === "rejected"
            ? "Admin has rejected — see admin comment"
            : event?.status === "published"
              ? "Your event is live — update or reschedule"
              : event?.status === "scheduled"
                ? "Scheduled — update or publish now"
                : "Waiting for admin approval";

    STEPS.push({
      name: "Review & Publish",
      description,
      path: ROUTES.REVIEW_AND_PUBLISH?.path?.replace(":id", event?.id ?? ""),
      info: "review_and_publish",
      render: true,
      validate: false,
      isAdminStep: true,
      eventStatus: event?.status,
    });
  }

  // Compute disabled: a step is disabled if any prior rendered+validate step is not yet in stepsInfo
  const renderedSteps = STEPS.filter((s) => s.render);

  return STEPS.map((step) => {
    if (!step.render) return { ...step, disabled: true };

    const pos = renderedSteps.findIndex((s) => s.info === step.info);

    if (pos === 0) return { ...step, disabled: false };

    const previousComplete = renderedSteps
      .slice(0, pos)
      .filter((s) => s.validate)
      .every((s) => stepsInfo.includes(s.info));

    return { ...step, disabled: !previousComplete };
  });
};

const useEventSteps = () => {
  const event = useSelector((state: RootState) => state.event);
  return getEventSteps(event);
};

export default useEventSteps;
